import { getOrigin } from 'core-lib/config/config';
import { setImageUrl } from 'shop/utils/helper';
import parkplusStoreV2RedirectionRoutes from '../constants/parkplusStoreV2RedirectionRoutes';
import Cart, { CartItem } from '../types/cart';
import { LocalStorage, SessionStorage } from 'core-lib/constants/storage';
import { checkStoreLocationServiceable } from 'core-lib/components/AddAddressV3/services/allProductServiceableApi';
import { checkValidAddress } from 'core-lib/components/AddAddressV3/utils/utils';

export const getImagesFromObjectArrays = (obj: any[], type: 1 | 2 = 1) =>
  obj?.map((item: any) => setImageUrl(item?.file, type));

export const calculateTotalCartValue = (cart: Cart) => {
  return cart?.data?.reduce((sum, item: CartItem) => {
    if (item?.discountedPrice > 0 && item?.quantity > 0) {
      sum += item.discountedPrice * item.quantity;
    }
    return sum;
  }, 0);
};

export function handleBarrelRedirection() {
  window.history.pushState(
    {},
    '',
    `${getOrigin()}/app${parkplusStoreV2RedirectionRoutes.fuelBarrel}`
  );
  window.location.href = `${getOrigin()}/app${
    parkplusStoreV2RedirectionRoutes.fuelBarrel
  }`;
}
export const calculateTotalCartMRP = (cart: Cart) => {
  return cart?.data?.reduce((sum, item: CartItem) => {
    if (item?.price > 0 && item?.quantity > 0) {
      sum += item.price * item.quantity;
    }
    return sum;
  }, 0);
};

export const serializeAddress = (address) => {
  return {
    id: address?.id || '',
    name: address?.metaData?.name || '',
    address_line_1: address?.address || '',
    address_line_2: address?.locality || '',
    city: address?.city || '',
    state: address?.state || '',
    state_code: address?.stateCode || '',
    pincode: address?.pincode || '',
    landmark: address?.landmark || '',
    latitude: address?.latitude || '',
    longitude: address?.longitude || '',
    address_type: address?.addressType || '',
    secondary_address_type: address?.addressTag || '',
    mobile_number: address?.metaData?.phone || '',
    email: address?.metaData?.email || '',
  };
};

export const checkIfAddressExist = (addressList, selectedAddress) => {
  return (
    addressList.findIndex((address) => address?.id === selectedAddress?.id) > -1
  );
};

export const checkServiceability = async (pincode) => {
  const { isServiceable, error } = await checkStoreLocationServiceable({
    pincode,
  });
  return isServiceable;
};

export const selectAddressLogic = async (addressList, selectedAddress) => {
  const result = addressList.find(
    (item) => item.addressTag.toUpperCase() === 'HOME'
  );
  const isNewAddress = JSON.parse(
    global.sessionStorage.getItem(SessionStorage.IsNewAddress)
  );
  const preSelectedAddress = JSON.parse(
    global.localStorage.getItem(LocalStorage.PreSelectedAddress)
  );

  let address = checkIfAddressExist(addressList, selectedAddress)
    ? selectedAddress
    : addressList[0];

  if (isNewAddress) {
    // if user added new address then select new address
    address = addressList[0];
    global.sessionStorage.removeItem(SessionStorage.IsNewAddress);
  } else if (
    preSelectedAddress &&
    checkValidAddress(preSelectedAddress) &&
    checkIfAddressExist(addressList, preSelectedAddress)
  ) {
    const addressIndex = addressList.findIndex(
      (address) => address?.id === preSelectedAddress?.id
    );
    // save selected address state for user session
    address = addressList[addressIndex];
  } else if (result) {
    // if above cases fails then select address having tag name HOME
    address = result;
  }

  return checkValidAddress(address) ? address : null;
};
